'use strict';

var handleDeepProperty = require('./handleDeepProperty');

function deepSetProperty(obj, key, val) {
  handleDeepProperty(obj, key, false, false, true, false, val);
  return obj;
}

module.exports = deepSetProperty;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/deepSetProperty.js
// module id = 440
// module chunks = 0